import React from 'react'
import { tv } from 'tailwind-variants'
import { IViewPortColumn } from 'components/spreadsheet/types'
import { getRowHeightVariable } from 'components/spreadsheet/helpers/functions'

interface Props {
  column: IViewPortColumn
  rowHeight: number
  value: string
}

const groupLoadingStyles = tv({
  base: 'border-r border-divider',
  variants: {
    frozen: {
      true: 'sticky z-[4]',
      false: 'absolute'
    },
    lastFrozen: {
      true: 'shadow-[3px_0_1px_var(--color-divider)]',
      false: 'shadow-none'
    }
  }
})

const GroupLoadingCell: React.FC<Props> = ({ column, rowHeight, value }) => {
  const heightPx = `${getRowHeightVariable(rowHeight)}px`
  const maxWidth = column.column.width - 40
  const isSticky = column.isFrozen

  return (
    <div
      className={groupLoadingStyles({ frozen: isSticky, lastFrozen: column.isLastFrozenColumn })}
      style={{
        width: `${column.column.width}px`,
        left: `${column.left}px`,
        height: heightPx
      }}
    >
      <div className="relative">
        <span style={{ maxWidth: `${maxWidth}px` }}>
          <span className="absolute inline-block break-words z-[2] pt-[5px] pb-0 px-[5px]">{value}</span>
        </span>
      </div>
    </div>
  )
}

export default GroupLoadingCell
